import cn from '../../../common/className.js'
import TextInput from '../../../common/components/TextInput.js'
import {
  isLabelPropertyEnabledSelector,
  labelConfigSelector,
} from '../../../data/labelInfos/index.js'
import EnableLabelProperty, {PickLabelProperty} from './EnableLabelProperty.js'
import useLabelProperty, {formatMetaClassName} from './useLabelProperty.js'
import {useSelector} from '../../../store.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'

/**
 * Common text input component for label info config
 *
 * @param {Object} props
 * @param {String} [props.className]
 * @param {String} [props.id]
 * @param {String} [props.label]
 * @param {Function} [props.Label]
 * @param {Any} [props.value]
 * @param {Boolean} [props.hide]
 * @param {Boolean} [props.disabled]
 * @param {String} [props.errorMessage]
 * @param {Function} props.onChange
 * @param {(String|Boolean)} [props.labelProperty]
 * @param {Object} [props.propertySpecs]
 * @param {Function} props.propertySpecs.labelPropertiesFunc
 * @param {Array} props.propertySpecs.validShipperTypes
 * @param {Function} props.propertySpecs.dependentPropertiesFunc
 * @param {Function} props.propertySpecs.validLabelPropertiesFunc
 * @param {Function} [props.labelPropertyCheckedSelector]
 * @returns {React.ReactNode}
 */
export default function ConfigTextInput({
  className,
  id,
  label,
  Label,
  value,
  hide,
  disabled,
  errorMessage,
  onChange,
  labelProperty,
  propertySpecs,
  labelPropertyCheckedSelector,
}) {
  const {labelInfoID, shipperType, isLabelEnableMode, isSummary, isPickMode} =
    useLabelConfigContext()

  labelProperty = labelProperty || ''
  id = id || `${labelInfoID}__${labelProperty}`

  useLabelProperty({
    labelProperty,
    propertySpecs,
  })

  const isLabelPropertyEnabled = useSelector((state) =>
    isLabelPropertyEnabledSelector(state, {
      labelInfoID,
      labelProperty,
    }),
  )

  value = useSelector((state) =>
    value === undefined
      ? labelConfigSelector(state, {labelInfoID})[labelProperty] || ''
      : value,
  )

  hide ||=
    !!shipperType && !propertySpecs.validShipperTypes.includes(shipperType)

  disabled ||= isLabelEnableMode && !isLabelPropertyEnabled

  if (hide) {
    return null
  }

  if (isSummary) {
    return label
  }

  if (isPickMode && !isLabelPropertyEnabled) {
    return (
      <PickLabelProperty
        label={label}
        labelProperty={labelProperty}
        checkedSelector={labelPropertyCheckedSelector}
      />
    )
  }

  return (
    <li
      className={cn`list__item--shipping-options btm-offset-7 ${formatMetaClassName(
        labelProperty,
      )} ${{'property-disabled': disabled}} ${className}`}
    >
      <div className="wrap--edit-preset-form-input wrap--edit-preset-form-input-md">
        {Label ? (
          <span className="label--config__txt">
            <Label />
          </span>
        ) : null}
        <TextInput
          labelClassName="label--bold label--config__txt"
          label={label}
          id={id}
          onChange={(newValue) => onChange(newValue)}
          value={value}
          disabled={disabled}
          errorMessage={errorMessage}
        />
      </div>
      <EnableLabelProperty
        labelProperty={labelProperty}
        checkedSelector={labelPropertyCheckedSelector}
      />
    </li>
  )
}
